import { Descriptions } from 'antd';
import { numberToString } from '@/std/format';
import type { Produto } from '../../types/Produto';

export function ProdutoSelectModalProduto({ produto }: { produto: Produto }) {
    return (
        <Descriptions
            bordered={true}
            column={1}
            items={[
                {
                    children: produto.pro_descricao,
                    key: 'nome',
                    label: 'Nome do produto',
                },
                {
                    children: produto.pro_codigo_interno,
                    key: 'codigo',
                    label: 'Código interno',
                },
                {
                    children: produto.pro_cod_barra || '—',
                    key: 'barras',
                    label: 'Código de barras',
                },
                {
                    children: produto.pro_sku || '—',
                    key: 'sku',
                    label: 'SKU',
                },
                {
                    children: numberToString(produto.estoque_total),
                    key: 'estoque',
                    label: 'Estoque total',
                },
                {
                    children: produto.produto_unidade?.pru_sigla,
                    key: 'unidade',
                    label: 'Unidade',
                },
            ]}
            size='small'
        />
    );
}
